import { API, CreateFieldInput } from "@thenounproject/lingo-core";
import { createAsyncAction } from "@actions/actionCreators";
import { toSnakeCase } from "@helpers/objectTransforms";

type Args = {
  spaceId: number;
  name: string;
  description?: string;
  displayOrder?: number | "append";
  fields?: CreateFieldInput[];
};

const [useCreateProductType, createProductType] = createAsyncAction(
  "productTypes/create",
  async ({ spaceId, name, description, displayOrder, fields }: Args) => {
    const res = await API.call<{ productType: string }>({
      endpoint: `spaces/${spaceId}/product-types`,
      method: "POST",
      data: {
        name,
        description,
        display_order: displayOrder,
        fields: toSnakeCase(fields),
      },
    });
    return { ...res, result: res.result.productType };
  }
);

export default useCreateProductType;
export { createProductType };
